<div class="pagination-container">
  <div class="pagination-go-page">
    Перейти на страницу: {{ firstPage() }} - {{ dailyFeedbackReportsPaginationData().totalPages }}
    <input
      #paginationInput
      class="pagination-input"
      type="number"
      placeholder="1"
      [value]="selectTablePage()"
      (keyup.enter)="goToPage(paginationInput.value)"
      (keydown)="preventInvalidNumericInput($event)"
      (input)="preventDecimalInput($event)"
    >
  </div>
  <mat-paginator
    showFirstLastButtons
    translate="no"
    [pageSize]="dailyFeedbackReportsPaginationData().size"
    [pageIndex]="dailyFeedbackReportsPaginationData().number"
    [length]="dailyFeedbackReportsPaginationData().totalElements"
    [pageSizeOptions]="pageSizeOptions()"
    (page)="changePageParams($event)"
  />
</div>
